module.exports = __webpack_public_path__ + "media/components/home/masthead-vectors/img/rebrand_1680x400-b5c2659eabdd4a168b4b75522fa457ee.jpg";